var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-wrapper" }, [
    _c("div", { staticClass: "form-wrapper-body m-0" }, [
      _c("div", { staticClass: "ActivityAftercareSetUpChildModalBody" }, [
        _c(
          "div",
          { staticClass: "customForm--container" },
          [
            _c(
              "keep-alive",
              [
                _c(_vm.customForm, {
                  key: _vm.customComponentRenderTrigger,
                  tag: "component",
                  attrs: {
                    customForm:
                      _vm.options.customForms[_vm.customComponentRenderTrigger]
                  },
                  on: {
                    errorInAnswer: function($event) {
                      _vm.disableButton = $event
                    }
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form-wrapper-footer d-flex justify-content-between" },
      [
        _c("div", [
          _c(
            "button",
            {
              class: ["form-wrapper-footer-button", "primary-btn"],
              style: { width: "150px" },
              on: { click: _vm.moveBack }
            },
            [_vm._v("\n        Go Back\n      ")]
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "button",
            {
              directives: [
                {
                  name: "spinner",
                  rawName: "v-spinner",
                  value: _vm.isLoading,
                  expression: "isLoading"
                }
              ],
              key: _vm.customComponentRenderTrigger,
              class: [
                "form-wrapper-footer-button",
                "primary-btn",
                _vm.options.activityStatus === "Full" &&
                  "form-wrapper-footer-button-waitlist",
                _vm.isLoading && "ie-spinner"
              ],
              style: { width: "150px" },
              attrs: { disabled: _vm.disableButton.includes(true) },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.moveForward($event)
                }
              }
            },
            [
              !_vm.finish
                ? [_vm._v("Continue")]
                : _vm.options.activityStatus === "Online"
                ? [
                    _vm._v(
                      _vm._s(_vm.isNewPaymentFlow ? "Pay Now" : "Add to Cart")
                    )
                  ]
                : _vm.options.activityStatus === "Full"
                ? [_vm._v(" Add to Waitlist ")]
                : _vm._e()
            ],
            2
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d1b8cc2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d1b8cc2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/CustomFormModal.vue
// module id = null
// module chunks = 